module.exports = __webpack_public_path__ + "img/ec.5e9624df.svg";